import { requiredString } from 'src/utils/schemas';
import * as yup from 'yup';

export const addFolderValidationSchema = yup
	.object()
	.shape({ name: requiredString, folderId: requiredString, isSection: yup.boolean().optional() });
